import cx from "classnames";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

// Utils
import { _O } from "../../modules/utils";

// UI
import { AlertPopup, Container, closeLayerFn, openLayerFn } from "../Layout";
import { MapView, mapLayer } from "../common/Modal/NaverMap";
import { VisitReceipt, pickerReStartFn } from "./Reservation.Layers";
import { getToday } from "./ResrvList";

// Provider
import {
  AppContext,
  LOG_OUT_SUCCESS,
  SET_GPSINFO2,
  SET_IDCARD_STATE,
  SocketCommand,
  socketManager,
} from "../../components/AppProvider";

// imageImport
import _icon_video_file from "../../resources/images/icon/icon_hospital_location.png";

import { Base64 } from "js-base64";
import { useInView } from "react-intersection-observer";
import { ListCardInfo } from "../../components";
import { CustomConfirmLayer } from "../../components/UI/Dialog";
import Labels from "../../components/UI/Label/Labels";
import { TextDiv } from "../../components/UI/List/ListCardInfo";
import {
  PostApi1972,
  PostApi273,
  PostApi274,
  PostApi275,
  PostApi278,
  PostApi999,
  PostApiHsptList,
} from "../../modules/network/padoPost";
import { checkNum10 } from "../../modules/utils/CheckLogic";
import { GetGpsInfo } from "../../modules/utils/GetGpsInfo";
import { NativeAction } from "../../modules/utils/HandleWs";
import { setCookie } from "../../modules/utils/cookie";
import { IC, ListIcon } from "../../resources/Assets";
import { getIdCard } from "../Nftf/Interface/NFTF/NativeApi";
import { request1914, request1916 } from "../Settings/Data";
import { reLogin } from "../common/AutoLogin/AutoLogin";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import HospitalReceiptBtn from "./HospitalReceiptBtn";
import useTitle from "../../modules/hooks/useTitle";

export const SUBS = [
  { url: "/surround", code: "SURND", label: "주변병원" },
  { url: "/resrvList", code: "RESRV", label: "예약현황" },
  { url: "/visit", code: "VISIT", label: "방문병원" },
];

export const SubMenu = props => {
  const { code } = props;

  return (
    <div className="top-roundtab-contain">
      <ul className="w3">
        {SUBS.map((m, i) => (
          <li key={i}>
            <Link to={m.url} className={cx({ on: code === m.code })}>
              {m.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const Nothing = props => {
  return (
    <div className="nothing-box">
      <div>
        <img src={_icon_video_file} alt="" />
        <p>검색된 병원이 없습니다.</p>
      </div>
    </div>
  );
};

// 의사목록
export const request275 = (
  userinfo,
  cfg,
  phonecfg,
  resrvType,
  hpKey,
  setDoctorList
) => {
  if (resrvType == "0") {
    PostApi275(userinfo, cfg, phonecfg, hpKey)
      .then(res => {
        if (res.resultMsg === "SUCCESS") setDoctorList(res.resultList);
      })
      .catch(err => {
        console.log(err);
      });
  }
};

// 병원목록
export const request273 = (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  hpAddr,
  setList,
  index,
  setTotRow
) => {
  PostApi273(userinfo, cfg, phonecfg, searchType, hpNm, hpAddr, index)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
        setList(res.resultList);
        setTotRow(res.totRow);
      }
    })
    .catch(err => {
      console.log(err);
    });
};

export const request274 = (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  hpAddr,
  setList,
  index,
  setTotRow
) => {
  PostApi274(userinfo, cfg, phonecfg, searchType, hpNm, hpAddr, index)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
        setList(res.resultList);
        setTotRow(res.totRow);
      }
    })
    .catch(err => {
      console.log(err);
    });
};

export const request278 = (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  hpAddr,
  setList
) => {
  PostApi278(userinfo, cfg, phonecfg, searchType, hpNm, hpAddr)
    .then(res => {
      if (res.resultMsg === "SUCCESS") {
        setList(res.resultList);
      }
    })
    .catch(err => {
      console.log(err);
    });
};

export const requestHsptList = (
  userinfo,
  cfg,
  phonecfg,
  searchType,
  hpNm,
  setList
) => {
  PostApiHsptList(userinfo, cfg, phonecfg, searchType, hpNm)
    .then(res => {
      if (res.resultMsg === "SUCCESS") setList(res.result.hsptList);
    })
    .catch(err => {
      console.log(err);
    });
};

export const SearchHospital = props => {
  const { onClickHpNm } = props;

  return (
    <div className="pr-section">
      <div className="pharmacy-search hos">
        <div>
          <input
            type="text"
            id="searchHpNm"
            className="textbox"
            placeholder="병원명을 입력해주세요."
            onKeyUp={e => {
              if (window.event.keyCode == 13) {
                onClickHpNm("HPNM");
              }
            }}
          />
          <a onClick={() => onClickHpNm("HPNM")}></a>
        </div>
        <div>
          <input
            type="text"
            id="searchHpAddr"
            className="textbox"
            placeholder="도로명 주소를 입력해주세요."
            onKeyUp={e => {
              if (window.event.keyCode == 13) {
                onClickHpNm("HPADDR");
              }
            }}
          />
          <a onClick={() => onClickHpNm("HPADDR")}></a>
        </div>
      </div>
    </div>
  );
};

export const HospitalList = props => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);
  const { idCardRegist } = props;
  const [cardRegist, setCardRegist] = useState(false);

  const {
    list,
    setDoctorList,
    setHpKey,
    setResrvType,
    setSelectHpNm,
    setHpLat,
    setHpLon,
    setCallSTime,
    setCallETime,
    addMode,
    setLocationInfo,
    setDialog,
  } = props;

  let nHour = getToday("FULL").substring(8, 10);
  let nMin = getToday("FULL").substring(10, 12);

  // const resrvLayer = (resrvType, hpNm, hpKey, setDoctorList, callSTime, callETime, appDr) => {
  const resrvLayer = (resrvType, hpNm, hpKey, setDoctorList, appDr) => {
    // if (getCookie("isAuthOk") == 9) {
    //   openLayerFn($(".confirm-layer"));
    //   return;
    // }

    let nDay = 0;
    let nHour = getToday("FULL").substring(8, 10);
    let nMin = getToday("FULL").substring(10, 12);

    if (nHour <= "12") {
      nDay = 0;
    } else {
      nDay = 1;
      nHour = parseInt(getToday("FULL").substring(8, 10)) - 12;
    }

    request275(userinfo, cfg, phonecfg, resrvType, hpKey, setDoctorList);

    openLayerFn($(".visit-receipt-layer"));
    pickerReStartFn(nDay, nHour, nMin);

    setHpKey(hpKey);
    setResrvType(resrvType);
    // setCallSTime(callSTime);
    // setCallETime(callETime);

    if (appDr == "1") {
      $("#doctorList").show();
    } else {
      $("#doctorList").hide();
    }
    $("#hpNm").val(hpNm);
  };

  const mapLayer = (hpNm, lat, lon, hospitalInfo) => {
    openLayerFn($(".map-view-layer"));

    NativeAction(phonecfg, "statusColor", "#FFFFFF");
    setSelectHpNm(hpNm);
    setHpLat(lat);
    setHpLon(lon);
    setLocationInfo(hospitalInfo);
  };

  // 병원등록 API
  const addHospital = hpKey => {
    request1914(userinfo, cfg, phonecfg, dispatch, "hpKey", "Y", hpKey);
  };

  const goReceipt = data => {
    _O.Open("/nftf/index/" + Base64.encode(JSON.stringify(data)));
  };

  const dupReceipt = () => {
    setDialog({
      type: "dup",
      title: "진료예약안내",
      msg: "이미 신청한 진료가 있습니다 병원진료는 중복신청이 불가합니다. 예약현황을 확인 후 다시 이용하세요",
      data: {},
    });
    openLayerFn($(".confirm-layer"));
  };

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.result.length > 0) {
          setCardRegist(true);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    getMyCardList();
    getIdCard(userinfo.userName);
  }, []);

  return (
    <div className="linebox-info-list">
      <ul>
        {list != null && (
          <Fragment>
            {list.length > 0 ? (
              list.map((m, i) => (
                <li key={"aaa" + i}>
                  <div className="line-box rep">
                    <div className="addr">
                      <span>
                        {m.hospital[0].hpName} ({m.hospital[0].address2})
                      </span>
                      {m.hospital[0].openTime ? (
                        <p>
                          {m.hospital[0].openTime.substring(0, 2) +
                            ":" +
                            m.hospital[0].openTime.substring(2, 4)}{" "}
                          ~{" "}
                          {m.hospital[0].closeTime.substring(0, 2) +
                            ":" +
                            m.hospital[0].closeTime.substring(2, 4)}{" "}
                          <em className="pp">
                            병원까지 {m.hospital[0].distance}
                          </em>
                        </p>
                      ) : (
                        <p>
                          <em className="pp">
                            병원까지 {m.hospital[0].distance}
                          </em>
                        </p>
                      )}
                    </div>
                    <div className="thr-btns" style={{ display: "flex" }}>
                      <a
                        onClick={() =>
                          mapLayer(
                            m.hospital[0].hpName,
                            m.hospital[0].latitude,
                            m.hospital[0].longitude,
                            m.hospital[0]
                          )
                        }
                        className="location btn-open-map"></a>

                      {addMode ? (
                        <a
                          className="hf btn-open-visit-receipt"
                          style={{ width: "100%" }}
                          onClick={() => addHospital(m.hospital[0].hpKey)}>
                          병원등록
                        </a>
                      ) : m.hospital[0].myhp != "0" ? (
                        <HospitalReceiptBtn
                          hsptInfo={m}
                          resrvLayer={resrvLayer}
                          dupReceipt={dupReceipt}
                          goReceipt={goReceipt}
                          setDoctorList={setDoctorList}
                        />
                      ) : (
                        <p style={{ width: "100%" }}>
                          접수 가능한 시간이 아닙니다.
                        </p>
                      )}
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <Nothing list={list} />
            )}
          </Fragment>
        )}
      </ul>
    </div>
  );
};

export const HospitalList2 = props => {
  const { userinfo, cfg, phonecfg, dispatch } = useContext(AppContext);

  const {
    list,
    setSelectHpNm,
    setHpLat,
    setHpLon,
    setHpKey,
    setLocationInfo,
    spclParam,
  } = props;

  // 병원등록 API
  const addHospital = hpKey => {
    // request1914(userinfo, cfg, phonecfg, dispatch, 'hpKey', 'Y', hpKey, "", "", spclParam);
    request1916(userinfo, cfg, phonecfg, dispatch, hpKey);
  };

  const styleA = {
    border: "0px",
  };

  return (
    <div className="linebox-info-list">
      <ul>
        {list != null && (
          <Fragment>
            {list.length > 0 ? (
              list.map((m, i) => (
                <li key={"aaa" + i}>
                  <div className="line-box rep">
                    <div className="addr">
                      <span>{m.hpName}</span>
                      <p>
                        {m.address3} {m.address4}
                      </p>
                      <p>Tel : {m.phone}</p>
                    </div>
                    <div className="thr-btns">
                      <a
                        onClick={() => mapLayer(phonecfg, setLocationInfo, m)}
                        className="location btn-open-map"
                        style={styleA}></a>

                      <a
                        className="hf btn-open-visit-receipt"
                        style={{ width: "100%", border: "0px" }}
                        onClick={() => addHospital(m.hpKey)}>
                        병원등록
                      </a>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <Nothing list={list} />
            )}
          </Fragment>
        )}
      </ul>
    </div>
  );
};

export default props => {
  useTitle("진료예약_주변병원");
  const [dialog, setDialog] = useState({
    type: "auth",
    title: "본인인증",
    msg: "해당 서비스를 정상적으로 이용하시려면 본인인증을 받으셔야합니다. 본인인증 화면으로 이동하겠습니까?",
    msg2: "",
    data: {},
  });

  const handleCancelCB = () => {
    if (dialog.type === "check") {
      null;
    } else {
      closeLayerFn($(".confirm-layer"));
      setList([]);
    }
  };

  const handleConfirmCB = () => {
    checkAction();
  };

  const checkAction = () => {
    sessionStorage.setItem("backUrl", "/surround");
    if (dialog.type === "check") {
      if (toggle) {
        setCookie("resrvCheckAlert", true, 365);
      }
      // _O.Open("/nftf/index/" + Base64.encode(JSON.stringify(dialog.data)));

      if (
        !localStorage.getItem("nftfNotice") ||
        JSON.parse(localStorage.getItem("nftfNotice")).check === false
      ) {
        _O.Open("/nftf/notice");
      } else {
        if (
          JSON.parse(localStorage.getItem("nftfNotice")).date ===
          new Date().getFullYear() +
            checkNum10(new Date().getMonth() + 1) +
            checkNum10(new Date().getDate())
        ) {
          _O.Open("/nftf/guide");
        } else {
          _O.Open("/nftf/notice");
        }
      }
    } else if (dialog.type === "auth") {
      _O.Open("/membership/certification");
    } else if (dialog.type === "dup") {
      _O.Open("/resrvList");
    }
  };

  // 서브메뉴 활성화 값 (기본 0)
  const sub = SUBS[0];

  const { userinfo, cfg, phonecfg, auth, dispatch, idCardState } =
    useContext(AppContext);
  const [searchType, setSearchType] = useState("");
  const [hpNm, setHpNm] = useState("");
  const [hpAddr, setHpAddr] = useState("");
  const [hpKey, setHpKey] = useState(""); // 선택된 병원키
  const [resrvType, setResrvType] = useState("0"); // 방문/전화 팝업 타입
  const [list, setList] = useState(null);
  const [totRow, setTotRow] = useState(0);

  const [hpLat, setHpLat] = useState("");
  const [hpLon, setHpLon] = useState("");
  const [selectHpNm, setSelectHpNm] = useState("");
  const [locationInfo, setLocationInfo] = useState({});

  const [callSTime, setCallSTime] = useState();
  const [callETime, setCallETime] = useState();

  const [doctorList, setDoctorList] = useState(null);

  const [handleCancelCBText, setHandleCancelCBText] = useState();
  const [handleConfirmCBText, setHandleConfirmCBText] = useState();

  const [toggle, setToggle] = useState(false);
  const [idCardRegist, setIdCardRegist] = useState(false);

  const [cardRegist, setCardRegist] = useState(false);

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  const getHsptList = () => {
    // searchType:: HPNM, HPADDR
    if ($("#searchHpNm").val() == "" && $("#searchHpAddr").val() == "") {
      request273(
        userinfo2,
        cfg,
        phonecfg,
        searchType,
        $("#searchHpNm").val(),
        $("#searchHpAddr").val(),
        setList,
        lastIndex,
        setTotRow
      );
    } else {
      request274(
        userinfo2,
        cfg,
        phonecfg,
        // searchType,
        $("#searchHpNm").val() != "" ? "HPNM" : "HPADDR",
        $("#searchHpNm").val(),
        $("#searchHpAddr").val(),
        setList,
        lastIndex,
        setTotRow
      );
    }
    setListView(true);
  };

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#B2BEE6");
  }, []);

  useEffect(() => {
    // window.NativeInterface = {
    //   getIdCardRtn: value1 => {
    //     if (value1 != "-1") {
    //       setIdCardRegist(true);
    //     } else {
    //       setIdCardRegist(false);
    //     }
    //   },
    // };

    if (phonecfg.phoneOS === "ANDROID") {
      if (parseInt(phonecfg.version.split(".")[2]) > 81) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    } else if (phonecfg.phoneOS === "IOS") {
      if (parseInt(phonecfg.version.split(".")[2]) > 35) {
        GetGpsInfo();
      } else {
        socketManager(SocketCommand.GET_GPS_INFO, undefined);
      }
    }
  }, []);

  useEffect(() => {
    if (idCardState.reload) {
      // if (idCardState.data.value1 != "-1") {
      if (
        idCardState &&
        idCardState.data &&
        idCardState.data != null &&
        idCardState.data.value1 != "-1"
      ) {
        setIdCardRegist(true);
      } else {
        setIdCardRegist(false);
      }

      dispatch({
        type: SET_IDCARD_STATE,
        data: { type: "RELOAD" },
      });
    }
  }, [idCardState.reload]);

  const { ref, inView } = useInView();

  const [lastIndex, setLastIndex] = useState(0);
  const [displayList, setDisplayList] = useState([]);
  const [resetState, setResetState] = useState(false);

  const resetPaging = () => {
    // setList([]);
    setList(null);
    setDisplayList([]);
    setLastIndex(1);
    setResetState(true);
  };

  useEffect(() => {
    if (!list || !Array.isArray(list)) {
      resetPaging();
      // return;
    } else if (inView) {
      if (resetState === false) {
        setLastIndex(lastIndex + 1);
      } else {
        setLastIndex(1);
      }
    }

    // displayList에 추가하기
  }, [inView]);

  useEffect(() => {
    // lastIndex값 증가시키기
    // 리스트 조회하기 (lastIndex 증가된 값 적용)
    // if (getCookie("isAuthOk") == 0) {
    PostApi999(phonecfg, cfg, userinfo.userToken)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.resultList === 1) {
            getHsptList();
          } else {
            openLayerFn($(".alert-layer-logout"));
          }
        }
      })
      .catch(err => {});
  }, [lastIndex]);

  useEffect(() => {
    if (list && list.length > 0) {
      console.log(list.length, displayList.length, totRow);
      if (resetState) {
        setDisplayList(list);
        setResetState(false);
      } else {
        if (displayList.length < totRow) {
          setDisplayList([...(displayList ?? []), ...(list ?? [])]);
        }
      }
    }
  }, [list]);

  const onClickHpNm = () => {
    resetPaging();
    getHsptList();
  };

  const goReceiptNotice = () => {
    sessionStorage.setItem("backUrl", "/surround");
    if (
      !localStorage.getItem("nftfNotice") ||
      JSON.parse(localStorage.getItem("nftfNotice")).check === false
    ) {
      _O.Open("/nftf/notice");
    } else {
      if (
        JSON.parse(localStorage.getItem("nftfNotice")).date ===
        new Date().getFullYear() +
          checkNum10(new Date().getMonth() + 1) +
          checkNum10(new Date().getDate())
      ) {
        _O.Open("/nftf/guide");
      } else {
        _O.Open("/nftf/notice");
      }
    }
  };

  const goReceipt = data => {
    goReceiptNotice();
  };

  const dupReceipt = () => {
    setDialog({
      type: "dup",
      title: "진료예약안내",
      msg: "이미 신청한 진료가 있습니다 병원진료는 중복신청이 불가합니다. 예약현황을 확인 후 다시 이용하세요",
      data: {},
    });
    openLayerFn($(".confirm-layer"));
  };

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.result.length > 0) {
          setCardRegist(true);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const resrvLayer = (resrvType, hpNm, hpKey, setDoctorList, appDr) => {
    let nDay = 0;
    let nHour = getToday("FULL").substring(8, 10);
    let nMin = getToday("FULL").substring(10, 12);

    if (nHour <= "12") {
      nDay = 0;
    } else {
      nDay = 1;
      nHour = parseInt(getToday("FULL").substring(8, 10)) - 12;
    }

    request275(userinfo, cfg, phonecfg, resrvType, hpKey, setDoctorList);

    openLayerFn($(".visit-receipt-layer"));
    pickerReStartFn(nDay, nHour, nMin);

    setHpKey(hpKey);
    setResrvType(resrvType);

    if (appDr == "1") {
      $("#doctorList").show();
    } else {
      $("#doctorList").hide();
    }
    $("#hpNm").val(hpNm);
  };

  useEffect(() => {
    getMyCardList();
    getIdCard(userinfo.userName);
  }, []);

  const nHour = getToday("FULL").substring(8, 10);
  const nMin = getToday("FULL").substring(10, 12);

  return (
    <Fragment>
      <ScrollToTop />
      <Container Title="주변병원" goToUrl="/" color="purple">
        <div className="contents sub grad">
          {/* subTabMenu */}
          <SubMenu code={sub.code} />
          {/* /subTabMenu */}

          <div className="sub-contents">
            {/* {병원명, 주소검색} */}
            <SearchHospital onClickHpNm={onClickHpNm} />
            {/* {병원명, 주소검색} */}

            <div
              style={{
                display: "flex",
                flexFlow: "column",
                gap: "12px",
                paddingTop: "40px",
              }}>
              {/* {list != null && ( */}
              {displayList != null && (
                <Fragment>
                  {displayList.length > 0 ? (
                    displayList.map((item, i) => (
                      <ListCardInfo
                        key={"ListCardInfo" + i}
                        status={"default"}
                        bodyInfoHeader={item.hospital[0].hpName}
                        bodyInfoBody={[
                          {
                            left: (
                              <TextDiv
                                color="#333"
                                fontWeight="600"
                                style={{ flex: "none" }}>
                                {item.hospital[0].distance}
                              </TextDiv>
                            ),
                            right: (
                              <TextDiv color="#888" fontWeight="400">
                                {item.hospital[0].address3}
                              </TextDiv>
                            ),
                          },
                        ]}
                        bodyInfoBodyAction={() => {
                          sessionStorage.setItem(
                            "receiptData",
                            Base64.encode(JSON.stringify(item.hospital[0]))
                          );
                          sessionStorage.setItem(
                            "hsptData",
                            Base64.encode(JSON.stringify(item))
                          );
                          sessionStorage.setItem("backUrl", "/surround");
                          _O.Open("/hspt/detail");
                        }}
                        bodyInfoBottom={
                          <Labels
                            labels={[
                              (item.hospital[0].receiptUseType.toString() ===
                                "2" ||
                                item.hospital[0].receiptUseType.toString() ===
                                  "9") && {
                                status: "active_green",
                                leftIcon: IC.camera.ICON_CAMERA_GREEN,
                                text: "비대면진료",
                              },
                              item.hospital[0].hpTypeNm &&
                                item.hospital[0].hpTypeNm != undefined &&
                                item.hospital[0].hpTypeNm != null &&
                                item.hospital[0].hpTypeNm != "" && {
                                  status: "default",
                                  text: item.hospital[0].hpTypeNm,
                                },
                            ]}
                          />
                        }
                        bodyIcon={[
                          {
                            icon: "",
                            action: false,
                          },
                          {
                            icon: ListIcon.RECEIPT.R_ICON.CHEVRON_DEFAULT,
                            action: () => {
                              sessionStorage.setItem(
                                "receiptData",
                                Base64.encode(JSON.stringify(item.hospital[0]))
                              );
                              sessionStorage.setItem(
                                "hsptData",
                                Base64.encode(JSON.stringify(item))
                              );
                              sessionStorage.setItem("backUrl", "/surround");
                              _O.Open("/hspt/detail");
                            },
                          },
                          {
                            icon: "",
                            action: false,
                          },
                        ]}
                        bottom={
                          item.hospital[0].myhp != "0"
                            ? [
                                (item.hospital[0].receiptUseType.toString() ===
                                  "1" ||
                                  item.hospital[0].receiptUseType.toString() ===
                                    "9") &&
                                  item.hospital[0].appSTime <= nHour + nMin &&
                                  item.hospital[0].appETime >= nHour + nMin && {
                                    text: "방문진료",
                                    action: () => {
                                      if (item.aplnBtnYn === "Y") {
                                        resrvLayer(
                                          "0",
                                          item.hospital[0].hpName,
                                          item.hospital[0].hpKey,
                                          setDoctorList,
                                          item.hospital[0].appDr
                                        );
                                        dispatch({
                                          type: "SET_NFTF_DOCTOR",
                                          data: null,
                                        });
                                      } else {
                                        dupReceipt();
                                      }
                                    },
                                  },
                                (item.hospital[0].receiptUseType.toString() ===
                                  "2" ||
                                  item.hospital[0].receiptUseType.toString() ===
                                    "9") &&
                                  item.hospital[0].callETime >=
                                    nHour + nMin && {
                                    text: "비대면진료",
                                    action: () => {
                                      // if (item.aplnBtnYn === "Y") {
                                      sessionStorage.setItem(
                                        "receiptData",
                                        Base64.encode(
                                          JSON.stringify(item.hospital[0])
                                        )
                                      );

                                      goReceipt(item.hospital[0]);
                                      dispatch({
                                        type: "SET_NFTF_DOCTOR",
                                        data: null,
                                      });
                                      // }
                                      //  else {
                                      //   dupReceipt();
                                      // }
                                    },
                                  },
                              ]
                            : [
                                {
                                  text: "접수 가능한 시간이 아닙니다.",
                                  action: () => alert("접수 불가"),
                                },
                              ]
                        }
                      />
                    ))
                  ) : (
                    <Nothing />
                  )}
                </Fragment>
              )}
            </div>
            {/* / 병원 리스트 */}
          </div>
          <div ref={ref} />
        </div>
      </Container>
      <VisitReceipt
        doctorList={doctorList}
        hpKey={hpKey}
        resrvType={resrvType}
        callSTime={callSTime}
        callETime={callETime}
      />
      <MapView
        hpLat={hpLat}
        hpLon={hpLon}
        selectHpNm={selectHpNm}
        locationInfo={locationInfo}
      />
      <AlertPopup color="PURPLE" />

      <CustomConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={handleConfirmCB}
        handleCancelCBText={
          // getCookie("isAuthOk") != 0 ? "닫기" : dialog.type === "check" ? "취소" : "닫기"
          dialog.type === "check" ? "취소" : "닫기"
        }
        handleCancelCB={handleCancelCB}
        // handleConfirmCBText={getCookie("isAuthOk") != 0 ? "확인" : "예약현황 확인"}
        handleConfirmCBText={
          dialog.type === "auth"
            ? "확인"
            : dialog.type === "dup"
            ? "예약현황 확인"
            : "확인"
        }
        // setCookieBtn={dialog.type === "check" ? true : false}
        toggle={toggle}
        setToggle={setToggle}
      />
    </Fragment>
  );
};
